import axios, { AxiosInstance } from 'axios'
import { interceptorApi } from 'services/Api/interceptors'
import { createAxiosMocks, getMocksServiceNow, getMocksMicrosoftGraph } from '__mocks__'
import store from 'store'

function createAxiosApisInstance(){

  /**
   * Verifica se o Cypress está autenticado
   * @returns boolean
   */ 
  const isCypressAuthenticated = () => {
      try {
          return sessionStorage.getItem('test.cypress.authenticated') === 'true'
      } catch {
          return false
      }
  }

  /**
   * Cria instâncias do Axios para ServiceNow e Microsoft Graph
   * com base nas URLs definidas nas variáveis de ambiente.
   */
  const axiosServiceNowApiInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_PROXY_URL
  })
  
  /**
   * Instância do Axios para Microsoft Graph API
   * com base na URL definida na variável de ambiente.
   */
  const axiosGraphApiInstance = axios.create({
    baseURL: process.env.REACT_APP_GRAPH_API_URL
  })
  
  /**
   * Se a flag do mock estiver ativada são criadas os 
   * requests fake baseados na estrutura "method", "url" e "data"
   */
  if (process.env.REACT_APP_HTTP_MOCK_ON === 'true' || isCypressAuthenticated()) {
    createAxiosMocks(getMocksServiceNow(), axiosServiceNowApiInstance)
    createAxiosMocks(getMocksMicrosoftGraph(), axiosGraphApiInstance)
  }
  
  let axiosGraphApi = interceptorApi?.addInterceptorsGraphApi(axiosGraphApiInstance)
  let axiosServiceNowApi = interceptorApi?.addInterceptorsServiceNowApi(axiosServiceNowApiInstance)
  //let axiosServiceNowApi = axiosServiceNowApiInstance
  
  axiosServiceNowApi?.interceptors.request.use(function (config) {
    const userId = store?.getState()?.authenticationReducers?.dataJwt?.mail
    if (userId) {
      config.data = {
        ...config.data,
        u_notifica_user: userId,
      }
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  return { axiosServiceNowApi, axiosGraphApi }
}

let { axiosServiceNowApi, axiosGraphApi } = createAxiosApisInstance()

export { axiosServiceNowApi, axiosGraphApi }